import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';


import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-loadconfirm',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loadconfirm.component.html',
  styleUrls: ['./loadconfirm.component.css'],
  animations: [
    trigger(
      'inbgOutAnimation',
      [
        transition(
          ':enter',
          [
            style({
              opacity: 0,
              zIndex: 4,
              position: 'absolute'
            }),
            animate('0.2s ease-out',
              style({ opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({
              opacity: 0,
              zIndex: 4,
              position: 'absolute'
            }),
            animate('0.2s ease-in',
              style({ opacity: 0 }))
          ]
        )
      ]
    )
  ]
})
export class LoadconfirmComponent {
  @Input() text: string;
  @Input() icon: string;
  @Input() iconclass: string;
  @Input() testloader: boolean = false;
  @Input() modalloader: boolean;
}
